export default __webpack_public_path__ + "static/media/10-bottom.9894c040.png";